export default __webpack_public_path__ + "images/3c4a4c954856ed40f9e37749ea731bfc.png";